import { render, staticRenderFns } from "./itUserProtocol.vue?vue&type=template&id=728b8e6c&scoped=true&"
import script from "./itUserProtocol.vue?vue&type=script&lang=js&"
export * from "./itUserProtocol.vue?vue&type=script&lang=js&"
import style0 from "./itUserProtocol.vue?vue&type=style&index=0&id=728b8e6c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728b8e6c",
  null
  
)

export default component.exports